import { ref, computed } from 'vue'
import { PhoneNumbersService } from '@/types/generated/services.gen'
import type { TPhoneNumber } from '@/types/generated/types.gen'

// Global state for phone numbers
const phoneNumbers = ref<TPhoneNumber[]>([])
const loading = ref(false)
const loaded = ref(false)

export function usePhoneNumbers() {
  const loadPhoneNumbers = async () => {
    if (loaded.value) return

    loading.value = true
    try {
      const response = await PhoneNumbersService.phoneNumbersList()
      phoneNumbers.value = response.results
      loaded.value = true
    } catch (error) {
      console.error('Error loading phone numbers:', error)
    } finally {
      loading.value = false
    }
  }

  const getPhoneNumberByUuid = (uuid: string): TPhoneNumber | undefined => {
    return phoneNumbers.value.find((pn: TPhoneNumber) => pn.uuid === uuid)
  }

  const getPhoneNumberDisplay = (uuid: string): string => {
    const phoneNumber = getPhoneNumberByUuid(uuid)
    if (!phoneNumber) return uuid // fallback to UUID if not found
    return phoneNumber.phone_number || phoneNumber.description || uuid
  }

  const clearCache = () => {
    phoneNumbers.value = []
    loaded.value = false
  }

  return {
    phoneNumbers: computed(() => phoneNumbers.value),
    loading: computed(() => loading.value),
    loaded: computed(() => loaded.value),
    loadPhoneNumbers,
    getPhoneNumberByUuid,
    getPhoneNumberDisplay,
    clearCache
  }
}
